import React from 'react';
import { FormattedMessage } from 'react-intl';

export default class ErrorMessage extends React.Component {
	render() {
		return (
			<div className="errorMessage">
				<span>
					<FormattedMessage
						id={this.props.message.id}
						defaultMessage={this.props.message.default}
					/>
				</span>
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./src/views/checkout/components/ErrorMessage.jsx